import { create } from 'zustand';

import type { RowToEdit } from './Form/RealEstateOwnedSummariesForm';

type RealEstateOwnedStore = {
  showForm: boolean;
  rowToEdit: RowToEdit | null;
  isEdit: boolean;
  openForEdit: (row: RowToEdit) => void;
  openForAdd: (row: RowToEdit) => void;
  closeForm: () => void;
};

export const useRealEstateOwnedStore = create<RealEstateOwnedStore>()(
  (set) => ({
    showForm: false,
    rowToEdit: null,
    isEdit: false,
    openForEdit: (row) => set({ showForm: true, rowToEdit: row, isEdit: true }),
    openForAdd: (row) => set({ showForm: true, rowToEdit: row, isEdit: false }),
    closeForm: () => set({ showForm: false, rowToEdit: null, isEdit: false }),
  }),
);
